exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-osmp-deliverable-modal .card-header{background-color:var(--wf-secondary);padding-left:.5rem}section.plan-settings{padding:10px 25px 25px 1px;.settings-header{display:flex;align-items:center;justify-content:flex-start;margin-left:0}.group-title{font-size:22px}.group-title h1{font-size:2.25rem;margin-top:1rem;margin-left:1rem}.settings-content{padding-top:0;.social-media-group-popup{padding:0;.row .col-5,.row .col-7{flex-basis:50%;max-width:50%}.type-label{display:none}}}}", ""]);

// exports
